module.exports = __webpack_public_path__ + "img/1363809578.49f2d919.jpg";